export const stripBase64Prefix = (value: string) => {
  return value.replace(/^data:[^;]+;base64,/, '');
};
